import {DeserializedRecord, Deserializer, JSONAPIRecord} from "../Helpers";
import {deserializeItem} from "../index";

interface TenantSubscriptionItem extends DeserializedRecord {
  itemPriceId: string;
  unitPrice: number;
}

interface Subscription extends DeserializedRecord {
  institutionName: string
}

interface TenantSubscription extends DeserializedRecord {
  id: string;
  billingPeriod: number,
  currentTermStartAt: Date,
  currentTermEndAt: Date,
  billingPeriodUnit: 'month' | 'year',
  currencyCode: 'EUR',
  status: string,
  externalName: string,
  description: string,
  subscriptionItems: TenantSubscriptionItem[]
}

interface TenantSubscriptionData extends JSONAPIRecord {
  attributes: {
    subscription_items: unknown[]
  }
}

interface TenantSubscriptionItemData extends JSONAPIRecord {
  item_price_id: string,
  object: string
}

const deserializeTenantSubscription: Deserializer<TenantSubscription, TenantSubscriptionData> = (data) => {
  const subscriptionItems: TenantSubscriptionItem[] = data.attributes.subscription_items
    .map((el: TenantSubscriptionItemData) => deserializeItem({id: el.item_price_id, type: el.object, attributes: el}));

  return {
    ...deserializeItem(data),
    subscriptionItems
  };
};

export {
  deserializeTenantSubscription,
  Subscription,
  TenantSubscriptionData,
  TenantSubscription,
  TenantSubscriptionItem
};
